import { Typography } from "@mui/material";
import type { StreamOutputStatsSnapshot } from "../utils/streamOutputs";

const labels: Record<string, string> = { waiting: "Waiting for matching SEI", forwarding: "Forwarding", unsupported: "Unsupported codec", stopped: "Stopped", error: "Output error" };
export default function SeiStatus({ stats, running = true }: { stats?: StreamOutputStatsSnapshot; running?: boolean }) {
  if (!stats?.sei) return null;
  const sei = stats.sei;
  const state = running ? sei.state : "stopped";
  return <Typography variant="caption" component="span" sx={{ display: "block", whiteSpace: "normal" }}>
    SEI · {labels[state] || state} · {sei.forwarded} forwarded · {sei.dropped} dropped
    {sei.lastMessageTime && ` · Last message: ${new Date(sei.lastMessageTime).toLocaleTimeString()}`}
    {stats.lastError && ` · ${stats.lastError}`}
  </Typography>;
}
